import { Injectable } from '@angular/core';
import { GoogleMeetMeetingAttendeeInterface, MeetingSource } from '@vendasta/meetings';
import { MeetingIntegrationsServiceModule } from '../meeting-integrations-service.module';
import { BaseMeetingService } from './base-meeting.service';
import { InstantMeetingSettings } from './interfaces/service-interfaces';

@Injectable({ providedIn: MeetingIntegrationsServiceModule })
export class ZoomMeetingService extends BaseMeetingService {
  protected getMeetingSource(): MeetingSource {
    return MeetingSource.MEETING_SOURCE_ZOOM;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  protected getAttendeesFromSettings(settings: InstantMeetingSettings): GoogleMeetMeetingAttendeeInterface[] {
    return [];
  }
}
